import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  message?: string;
};

const Loader = ({ message }: Props) => {
  const { t } = useTranslation('common');
  const dot2 = useRef<HTMLSpanElement>(null);
  const dot3 = useRef<HTMLSpanElement>(null);
  const loadingMessage = useRef<HTMLParagraphElement>(null);

  const [changingMessage, setChangingMessage] = useState(message);

  useEffect(() => {
    // CHANGE MESSAGE AFTER 2 SECONDS
    setTimeout(() => {
      if (loadingMessage.current && changingMessage !== 'レンダリング中') {
        loadingMessage.current.classList.add('opacity-0');
        setTimeout(() => {
          loadingMessage.current?.classList.remove('opacity-0');
          setChangingMessage('レンダリング中');
        }, 200);
      }
    }, 2000);

    // CHANGE TAB TITLE
    const baseTitle = t('viewer.loadingModel');
    let dotCount = 1;
    document.title = `${baseTitle}${'.'.repeat(dotCount)}`;

    const titleInterval = setInterval(() => {
      dotCount = (dotCount % 3) + 1;
      document.title = `${baseTitle}${'.'.repeat(dotCount)}`;
    }, 300);

    // ANIMATE LAST TWO DOTS WITH DELAYS AND INTERVALS
    const interval = setInterval(() => {
      dot2.current?.classList.toggle('opacity-0');
      setTimeout(() => {
        dot3.current?.classList.toggle('opacity-0');
      }, 300);
      setTimeout(() => {
        dot2.current?.classList.toggle('opacity-0');
        dot3.current?.classList.toggle('opacity-0');
      }, 600);
    }, 900);

    // Cleanup intervals on unmount
    return () => {
      clearInterval(titleInterval);
      clearInterval(interval);
      document.title = 'AgentCAD';
    };
  }, [changingMessage, t]);

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="relative h-24 w-24">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-[3px] border-synergy-neutral-800 border-t-synergy-blue" />
        </div>
      </div>
      {message && (
        <p
          ref={loadingMessage}
          className="mt-3 text-sm text-synergy-text-secondary transition-opacity duration-200"
        >
          {changingMessage === 'レンダリング中' ? t('viewer.rendering') : changingMessage}
          <span>.</span>
          <span
            ref={dot2}
            className="opacity-0 transition-opacity duration-200"
          >
            .
          </span>
          <span
            ref={dot3}
            className="opacity-0 transition-opacity duration-200"
          >
            .
          </span>
        </p>
      )}
    </div>
  );
};

export default Loader;
